<!--说明-->
<!--1.type值12345对应A1、A2、A3、A4、B型题-->
<!--2.optionFlag表示多选还是单选-->
<!--3.B型题没有大题的题干。-->
<template>
  <div style="position: relative">
    <SafeAreaInsetBottom>
      <div class="Topic" @touchstart="touchstart" @touchend="touchend">
        <div
          class="display"
          v-if="
            T.type && T.questionId && Array.isArray(T.index) && T.optionFlag
          "
        >
          <div class="topic-top">
            <div
              style="display: flex;flex-direction: column"
              class="stemDescription"
              v-if="T.type == 1 || T.type == 2 || T.type == 3 || T.type == 4"
            >
              <div
                style="margin-right:10px; padding-top: 8px;"
                v-if="T.type == 1 || T.type == 2"
              >
                <template v-if="showIndex">{{ T.index[0] }}. </template>
                <TopicType :t="T.optionFlag" v-bind="$attrs" />
              </div>
              <div class="title-html" style="flex: 1">
                <div v-html="T.stemDescriptionHtml"></div>
              </div>
            </div>
            <div
              class="stemDescription"
              v-if="T.type == 5 && Array.isArray(T.optionContent)"
            >
              <div
                class="b-type-btn"
                v-if="!BTypeTopicOption"
                @click="BTypeTopicOption = true"
              >
                点击查看【b型题】公共选项
              </div>
              <div v-if="BTypeTopicOption" @click="BTypeTopicOption = false">
                <p>【b型题】公共选项</p>
                <ul class="common-option-ul">
                  <li
                    v-for="option in T.optionContent"
                    :key="option.optionTypeDesc"
                    class="common-option"
                  >
                    <span>{{ option.optionTypeDesc }}</span>
                    <div
                      class="option-name"
                      v-html="option.optionTextHtml"
                    ></div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="topic-content">
            <div v-if="T.type == 1 || T.type == 2">
              <TopicOptions
                :optionFlag="T.optionFlag"
                :optionContent="T.optionContent"
                :answer="isHistory ? T.answer : []"
                v-model="T.userAnswer"
              />
            </div>
            <div v-else>
              <ul>
                <li v-for="q in T.sonQuestion" :key="q.questionId">
                  <div class="son-question-title">
                    <div class="no">
                      <p>
                        <template v-if="showIndex">{{ q.index[0] }}.</template>
                        <TopicType :t="T.optionFlag" v-bind="$attrs" />
                      </p>
                    </div>
                    <div class="title" v-html="q.stemDescriptionHtml"></div>
                  </div>
                  <TopicOptions
                    :optionFlag="T.optionFlag"
                    :optionContent="q.optionContent"
                    :answer="isHistory ? q.answer : []"
                    v-model="q.userAnswer"
                  />
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div v-else style="text-align: center;padding: 30px">
          数据加载中
        </div>
      </div>
    </SafeAreaInsetBottom>
  </div>
</template>

<script>
import TopicType from "./TopicType.vue";
import TopicOptions from "./TopicOptions.vue";
import SafeAreaInsetBottom from "@/components/safeAreaInsetBottom/SafeAreaInsetBottom.vue";
const isMoveDistanceVal = (document.documentElement.clientWidth / 8) * 3; //左右滑动的距离触发切换题目
export default {
  name: "Topic",
  props: {
    T: {
      //当前大题对象
      type: Object,
      default: function() {
        return {};
      }
    },
    isHistory: {
      type: Boolean,
      default: false //目前有多处地方使用默认值，请勿随意修改
    },
    showIndex: {
      type: Boolean,
      default: true
    }
  },
  data: function() {
    return {
      startClientX: 0,
      BTypeTopicOption: false
    };
  },
  mounted: function() {},
  methods: {
    touchstart(e) {
      this.startClientX = e.changedTouches[0].clientX;
    },
    touchend(e) {
      let endClientX = e.changedTouches[0].clientX;
      if (this.startClientX > endClientX) {
        //下一题
        if (this.startClientX - endClientX > isMoveDistanceVal) {
          this.$emit("swipe", 1);
        }
      } else {
        //上一题
        if (endClientX - this.startClientX > isMoveDistanceVal) {
          this.$emit("swipe", 0);
        }
      }
    }
  },
  components: { TopicOptions, TopicType, SafeAreaInsetBottom }
};
</script>

<style lang="scss">
.Topic {
  overflow: hidden;
  background: #fff;
  video {
    width: 100%;
  }
  img {
    width: 100%;
  }
  audio {
    width: 100%;
  }
  .topic-top {
    width: 100%;
    padding: 8px 15px 0;
    background: #fff;
    .stemDescription {
      background: #fff6f5;
      display: block;
      padding: 4px 15px;
      color: #222;
      font-size: 15px;
      .title-html {
      }
      p {
        margin: 6px 0;
        word-break: break-all;
      }
    }
    .common-option-ul {
      margin: 0;
      .common-option {
        overflow-x: auto;
        display: flex;
        align-items: center;
        span {
          width: 20px;
        }
        .option-name {
          flex: 1;
          p {
            word-break: break-all;
          }
        }
      }
    }
  }
  .topic-content {
    padding: 15px 16px 60px 16px;
    background: #fff;
    .son-question-title {
      display: flex;
      flex-direction: column;
      /*align-items: center;*/
      .no {
        flex-grow: 0;
        margin-bottom: 0;
        p {
          margin: 0;
        }
      }
      .title {
        flex: 1;
        margin-top: 0;
        table-layout: fixed;
        word-break: break-all;
        overflow: hidden;
        > p {
          margin-top: 6px;
        }
      }
    }
  }
  .b-type-btn {
    color: #222222;
    padding: 16px 0;
    font-weight: bold;
    font-size: 15px;
  }
}
</style>
